module.exports = __webpack_public_path__ + "img/abdo.cb949431.jpg";